import { useEffect } from 'react';

export default function useScrollReveal(containerRef, selector = '.reveal', threshold = 0.12) {
  useEffect(() => {
    const root = containerRef?.current ?? document;
    const els = root.querySelectorAll(selector);
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          observer.unobserve(e.target);
        }
      }),
      { threshold }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  });
}
